import {store} from "../store";
import {canBePickedUp, isProductDisabled} from "../libraries/utils";
import _ from "lodash";
import {isMenu, isSpecificProductGroupType} from "../domains2/libraries/Utils";

export const noThanksObject = {
	id: "999999",
	name: "No thanks",
	imageLinks: ["123T144/nej-tak-v1-cropped.png", "123T144/nej-tak-v1-cropped_thumb.png"]
};

export const isNoThanksProductId = (id) => {
	const product = store.getters.productCatalog.getProduct(id, true);
	return isNoThanksProduct(product);
};

export const isNoThanksProduct = (product) => {
	if (isProductDisabled(product)) {
		return false;
	}
	return product.options.isNoThanks;
};
export const containsNoThanks = (group) => {
	return group.products.find(product => {
		return isNoThanksProduct(product);
	});
};
export const mapGroups = (productCatalog, item, callbackFn) => {
	if(item.groups) {
		return item.groups.map(group => {
			const isMenuProduct = group.productId ? isMenu(productCatalog, group.productId) : false;
			if(isMenuProduct) {
				const newProduct = group.products.length === 1 ? group.products[0] : {};
				mapGroups(productCatalog, newProduct, callbackFn);
			} else {
				return callbackFn(group);
			}
		});
	} else {
		return item;
	}
};
export const differentiateGroup = (group) => {
	const splitProducts = (array, callback) =>
		array.filter(product => product.isActive).reduce((acc, item) => {
			acc[callback(item) ? 0 : 1].push(item);
			return acc;
		}, [[], []]);
	const [upsellProducts, defaultProducts] = splitProducts(group.products, (p => _.get(p, ["productGroupDetails", group.id, "additionalDetails", "upsellProduct"])));

	const filteredUpsellProducts = upsellProducts.filter((product) => {
		return canBePickedUp(
			product,
			store.getters.productCatalog,
			store.getters.cachedPickupRules,
			store.getters.globalSelectedShop.id
		) && !isNoThanksProduct(product);
	});

	const filteredDefaultProducts = defaultProducts.filter((product) => {
		return canBePickedUp(
			product,
			store.getters.productCatalog,
			store.getters.cachedPickupRules,
			store.getters.globalSelectedShop.id
		) && !isNoThanksProduct(product);
	});

	const upsellProductsWithNoThanks = filteredUpsellProducts.length > 0
		? [...filteredUpsellProducts, noThanksObject]
		: [];
	const defaultProductWithNoThanks = filteredUpsellProducts.length === 0 && filteredDefaultProducts.length > 0
		? [...filteredDefaultProducts, noThanksObject]
		: filteredDefaultProducts;

	return {
		...group,
		products: {
			upsell: upsellProductsWithNoThanks,
			default: defaultProductWithNoThanks
		}
	};
};
export const generateDifferentiatedGroups = (item) => {
	mapGroups(store.getters.productCatalog, item, (group) => {
		let differentiatedGroup = {};
		const hasUpsellProducts = !isSpecificProductGroupType(group, "addons") && group.products.find(p => _.get(p, ["productGroupDetails", group.id, "additionalDetails", "upsellProduct"]));
		if(hasUpsellProducts) {
			differentiatedGroup = differentiateGroup(group);
			item.differentiatedGroup = differentiatedGroup;
		}
		return hasUpsellProducts ? differentiatedGroup : group;
	});
};
